import {
  envKeys,
  googleMapApiKeys,
  smokeballApiKeys,
  launchDarklyKeys,
  captchaKeys,
} from "@smart/bridge-env-types-basic";
import { buildApiGatewayDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { keysOf } from "@smart/itops-utils-basic";

import { system } from "./base";
import { cdn } from "./cloudfront";

const lambdaDefs = {
  createSubmission: {
    pkg: "@smart/intake-create-submission-lambda",
    deployable: "createSubmission",
    method: "POST",
    authenticated: false,
    env: [],
  },
  load: {
    pkg: "@smart/intake-load-lambda",
    deployable: "load",
    method: "GET",
    authenticated: false,
    env: [...smokeballApiKeys, ...launchDarklyKeys],
  },
  submit: {
    pkg: "@smart/intake-submit-lambda",
    deployable: "submit",
    method: "POST",
    authenticated: false,
    env: [...captchaKeys, ...launchDarklyKeys, ...smokeballApiKeys],
  },
  searchAddress: {
    pkg: "@smart/intake-search-address-lambda",
    deployable: "searchAddress",
    method: "GET",
    authenticated: false,
    env: [...googleMapApiKeys],
  },
  getAddress: {
    pkg: "@smart/intake-get-address-lambda",
    deployable: "getAddress",
    method: "POST",
    authenticated: false,
    env: [...googleMapApiKeys],
  },
  uploadFile: {
    pkg: "@smart/intake-upload-file-lambda",
    deployable: "uploadFile",
    method: "POST",
    authenticated: false,
    env: [],
  },
  captcha: {
    pkg: "@smart/intake-captcha-lambda",
    deployable: "captcha",
    method: "POST",
    authenticated: false,
    env: [...captchaKeys],
  },
  signNotify: {
    pkg: "@smart/intake-sign-notify-lambda",
    deployable: "signNotify",
    method: "GET",
    authenticated: false,
    env: [],
  },
  analyticsEvent: {
    pkg: "@smart/intake-analytics-event-lambda",
    deployable: "analyticsEvent",
    method: "POST",
    authenticated: false,
    env: [...smokeballApiKeys],
  },
} as const;

export const apiGateway = buildApiGatewayDef({
  envKeys,
  cdn,
  namespace: buildNamespace({ system, entity: "intake" }),
  prefix: "api",
  authorized: false,
  authorizer: undefined,
  lambdaKeys: keysOf(lambdaDefs),
  lambdas: lambdaDefs,
  port: 9101,
});
